import { useContext } from 'react';

import { MerchantInfoContext } from '../context';

export const useMerchantInfo = () => useContext(MerchantInfoContext);
